import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
import cn from 'classnames';
import { ScrollableList, CustomModal, Typography } from 'seagull';
import { useResponsive } from '~/client-flow/contexts';
import { useStoreActions } from '~/contexts';
import { useTutorialVideos } from '~/hooks/useTutorialVideos/useTutorialVideos';
import styles from './TutorialVideosModal.module.scss';
import { TutorialVideosPlayedVideo } from './TutorialVideosPlayedVideo';
import { VideoCardItem } from './VideoCardItem/VideoCardItem';
export default function TutorialVideosModal(param) {
    let { dismissModal } = param;
    const { videos, handleWatch } = useTutorialVideos();
    const { logBI } = useStoreActions();
    const [currentVideo, setCurrentVideo] = useState(null);
    const { isPortrait } = useResponsive();
    const playerContainerRef = useRef(null);
    const [playerHeight, setPlayerHeight] = useState(undefined);
    useEffect(()=>{
        if (videos.length > 0 && !currentVideo) {
            setCurrentVideo(videos[0]);
        }
    }, [
        currentVideo,
        videos
    ]);
    useEffect(()=>{
        if (!playerContainerRef.current || isPortrait) {
            setPlayerHeight(undefined);
            return;
        }
        const updateHeight = ()=>{
            if (playerContainerRef.current) {
                setPlayerHeight(playerContainerRef.current.offsetHeight);
            }
        };
        updateHeight();
        const resizeObserver = new ResizeObserver(()=>{
            updateHeight();
        });
        resizeObserver.observe(playerContainerRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        currentVideo,
        isPortrait
    ]);
    const allVideos = videos.slice(0, -1);
    const lastVideo = videos[videos.length - 1];
    const videoSlider = /*#__PURE__*/ _jsxs(ScrollableList, _object_spread_props(_object_spread({
        direction: "vertical",
        maxSize: isPortrait ? '100%' : playerHeight ? "".concat(playerHeight + 24, "px") : '100%',
        gap: 8
    }, isPortrait && {
        itemsInView: 3.5,
        itemMaxSize: 224
    }), {
        children: [
            allVideos.map((video)=>/*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(VideoCardItem, {
                        video: video,
                        onSelect: setCurrentVideo,
                        isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === video.id,
                        variant: isPortrait ? 'portrait' : 'desktop'
                    })
                }, video.id)),
            /*#__PURE__*/ _jsx("div", {
                className: styles.lastVideoContainer,
                children: /*#__PURE__*/ _jsx(VideoCardItem, {
                    video: lastVideo,
                    onSelect: setCurrentVideo,
                    isActive: (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id) === lastVideo.id,
                    variant: isPortrait ? 'portrait' : 'desktop'
                })
            }, lastVideo.id)
        ]
    }));
    const mobileProps = {
        width: '100%',
        contentUseFullWidth: true,
        style: {
            position: 'absolute',
            top: 0,
            left: 0
        },
        maxHeight: 'calc(100% - 32px)'
    };
    return /*#__PURE__*/ _jsx(CustomModal, _object_spread_props(_object_spread({
        bi: {
            closeButton: {
                name: 'tutorial_videos_modal_close'
            }
        },
        contentUseFullWidth: true,
        className: cn(styles.TutorialVideosModal, {
            [styles.isPortrait]: isPortrait
        }),
        maxWidth: "calc(100% - 128px)",
        onClose: ()=>{
            if (currentVideo) {
                logBI(11216, {
                    videoId: currentVideo.id,
                    title: currentVideo.title
                });
            }
            dismissModal();
        },
        headerClassName: styles.modalTitle,
        header: /*#__PURE__*/ _jsx(Typography, {
            weight: "bold",
            testId: "tutorial-videos-modal-title",
            children: "Explore tutorials"
        })
    }, isPortrait && mobileProps), {
        children: /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.modalContent, {
                [styles.isPortrait]: isPortrait
            }),
            children: [
                currentVideo && /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.responsivePlayerContainer, {
                        [styles.isPortrait]: isPortrait
                    }),
                    ref: playerContainerRef,
                    children: /*#__PURE__*/ _jsx("div", {
                        className: styles.responsivePlayer,
                        children: /*#__PURE__*/ _jsx(TutorialVideosPlayedVideo, {
                            video: currentVideo,
                            onWatch: handleWatch
                        })
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: cn(styles.modalVideosSliderContainer, {
                        [styles.isPortrait]: isPortrait
                    }),
                    children: videoSlider
                })
            ]
        })
    }));
}
